<template>
  <module-block
    block="light"
    class="home-dentists"
  >
    <div class="home-dentists__inner group group--first-last">
      <div
        :class="[
          `home-dentists__image`,
          `home-dentists__image--${animationClass ? `open` : `closed`}`,
        ]"
      >
        <div class="home-dentists__image-wrapper">
          <img
            v-for="(image, index) in images.pages"
            :key="index"

            :class="[
              `home-dentists__paper`,
              `home-dentists__paper--${index}`,
            ]"

            :src="image"
          >
        </div>
      </div>
      <div class="home-dentists__content">
        <h2 class="h3 mt0 home-dentists__heading">{{ heading }}</h2>
        <p
          v-for="(p, index) in copy"
          :key="index"

          class="p"

          v-html="p"
        />
        <div class="home-dentists__form">
          <module-form
            form-id="register-dentist"
            :fields="{
              dentistEmail: {
                type: `email`,
                label: `Email`,
                labelHidden: true,
                placeholder: `Enter Your Email`,
              },
            }"

            button="primary"
            submit="Sign up now"
            :action="action"
            :success="success"
            :fail="fail"
          />
        </div>
      </div>
    </div>
  </module-block>
</template>

<script>
// Vuex
import { mapGetters, mapActions } from 'vuex';

// Services
import { createScroll, destroyScroll } from 'services/scroll';

// Modules
import ModuleBlock from 'modules/Block';
import ModuleForm from 'modules/Form';

// Images
const images = {
  pages: {
    'four': require(`images/home/dentists-page-3.svg`),
    'three': require(`images/home/dentists-page-2.svg`),
    'two': require(`images/home/dentists-page-4.svg`),
    'one': require(`images/home/dentists-page-1.svg`),
  },
};

// Export
export default {
  name: `home-dentists`,

  // Compononts
  components: {
    ModuleBlock,
    ModuleForm,
  },

  // Data
  data () {
    return {
      animationClass: false,
      images,
      heading: `Are you a Dentist or Endodontist and want to help?`,
      copy: [
        `Join the growing team of experts who want to highlight quality in the dental field. We're always looking for more reviewers, advisors and thought leaders. Please sign up now and we'll send you information on how you can get involved.`,
      ],
    };
  },
  computed: {
    ...mapGetters(`auth`, [
      `isAuthenticated`,
    ]),
    ...mapGetters(`forms`, [
      `getModel`,
    ]),
  },

  // Methods
  methods: {
    ...mapActions(`auth`, [
      `requestLogout`,
    ]),
    animation() {
      this.animationClass = !this.animationClass;
    },
    action() {
      const model = this.getModel(`register-dentist`);

      sessionStorage.setItem(`dentist_email`, model.dentistEmail || ``);

      if (this.isAuthenticated) {
        this.requestLogout({
          noRedirect: true,
        });
      }

      return new Promise(resolve => {
        setTimeout(() => {
          resolve();
        }, 500);
      });
    },
    success() {
      setTimeout(() => {
        this.$router.push({
          name: `register-dentist`,
        });
      }, 500);
    },
    fail(fail) {
      console.warn(fail);
    },
  },

  // Lifecycle
  mounted() {
    createScroll(`dentists-papers`, {
      el: this.$el,
      move: e => {
        if(e.top.topPercent >= -50) {
          this.animationClass = true;
        }
        else if (e.top.topPercent < -100) {
          this.animationClass = false;
        }
      },
    });
  },
  destroyed() {
    destroyScroll(`dentists-papers`);
  },
};
</script>



// WEBPACK FOOTER //
// Dentists.vue?0ee5f0e7